var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#19B9E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6052 9.30894L18.5777 9.37311L15.9194 15.5423H13.3069C12.6835 15.5423 12.0877 15.6706 11.5469 15.8998L13.151 12.0681L13.1877 11.9764L13.2519 11.8298C13.2702 11.7748 13.2885 11.7198 13.316 11.6739C14.5169 8.89644 15.8735 8.26394 18.6052 9.30894Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5466 15.7253C23.1341 15.5969 22.6941 15.5419 22.2541 15.5419H15.9199L18.5783 9.37276L18.6058 9.30859C18.7433 9.35443 18.8716 9.41859 19.0091 9.47359L21.0349 10.3261C22.1624 10.7936 22.9508 11.2794 23.4274 11.8661C23.5191 11.9761 23.5924 12.0769 23.6566 12.1961C23.7391 12.3244 23.8033 12.4528 23.8399 12.5903C23.8766 12.6728 23.9041 12.7553 23.9224 12.8286C24.1699 13.5986 24.0233 14.5428 23.5466 15.7253Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7279 20.0143V21.8018C26.7279 21.9852 26.7188 22.1685 26.7096 22.3518C26.5354 25.551 24.7479 27.1643 21.3562 27.1643H14.2063C13.9863 27.1643 13.7662 27.146 13.5554 27.1185C10.6404 26.926 9.08208 25.3677 8.88958 22.4527C8.86208 22.2418 8.84375 22.0218 8.84375 21.8018V20.0143C8.84375 18.1718 9.96208 16.586 11.5571 15.8985C12.1071 15.6693 12.6938 15.541 13.3171 15.541H22.2637C22.7129 15.541 23.1529 15.6052 23.5562 15.7243C25.3804 16.2835 26.7279 17.9885 26.7279 20.0143Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1515 12.0664L11.5473 15.8981C9.95232 16.5856 8.83398 18.1714 8.83398 20.0139V17.3281C8.83398 14.7247 10.6857 12.5522 13.1515 12.0664Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7264 17.329V20.0148C26.7264 17.9982 25.388 16.284 23.5547 15.734C24.0314 14.5423 24.1689 13.6073 23.9397 12.8282C23.9214 12.7457 23.8939 12.6632 23.8572 12.5898C25.5622 13.4698 26.7264 15.2757 26.7264 17.329Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletBlue);
export default __webpack_public_path__ + "static/media/wallet-blue.65c572345a78b47dbf815c987f53dcb4.svg";
export { ForwardRef as ReactComponent };